<comp-dialog>
  <ng-container comp-dialog-header-title>
    {{ 'switchTenant.title' | translate }}
  </ng-container>
  <ng-container comp-dialog-content>
    @if (data.tenants.length === 0) {
      <p>{{ 'switchTenant.noTenants' | translate }}</p>
    } @else {
      <mat-form-field appearance="outline" class="outlined-form-element">
        <mat-label>{{ 'switchTenant.selectTenant' | translate }}</mat-label>
        <mat-select [value]="selectedTenantId()" (valueChange)="selectedTenantId.set($event)">
          @for (tenant of data.tenants; track tenant.tenantId ?? tenant.id) {
            <mat-option [value]="tenant.tenantId" [disabled]="!tenant.tenantId">
              {{ tenant.name }} ({{ tenant.tenantId }})
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </ng-container>
  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        <button comp-button="secondary" type="button" mat-dialog-close>
          {{ 'general.cancel' | translate }}
        </button>
        <button
          comp-button
          action="save"
          type="submit"
          [disabled]="!selectedTenantId()"
          (click)="save()"
        >
          {{ 'general.save' | translate }}
        </button>
      </ng-container>
    </comp-card-buttons>
  </ng-container>
</comp-dialog>
